import React from 'react'
import { Menu, Icon, Button } from "antd"

const { SubMenu } = Menu

class LeftNav extends React.Component {
    state = {
        collapsed: false,
    }

    toggleCollapsed = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        })
    }

    render() {
        return (
            <div style={{ width: 256 }}>
                <Menu
                    defaultSelectedKeys={["1"]}
                    defaultOpenKeys={["sub1"]}
                    mode="inline"
                    theme="dark"
                    inlineCollapsed={this.state.collapsed}
                >
                    <Menu.Item key="1">
                        <Icon type="pie-chart" />
                        <span>激活账号</span>
                    </Menu.Item>
                    <Menu.Item key="2">
                        <Icon type="desktop" />
                        <span>忘记密码</span>
                    </Menu.Item>
                    <Menu.Item key="3">
                        <Icon type="inbox" />
                        <span>密码申述</span>
                    </Menu.Item>
                    <SubMenu
                        key="sub1"
                        title={
                            <span>
                                <Icon type="mail" />
                                <span>密码申述查询</span>
                            </span>
                        }
                    >
                        <Menu.Item key="5">Option 5</Menu.Item>
                        <Menu.Item key="6">Option 6</Menu.Item>
                        <Menu.Item key="7">Option 7</Menu.Item>
                        <Menu.Item key="8">Option 8</Menu.Item> 
                    </SubMenu>
                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>修改密码</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">更换手机</Menu.Item>
                        <Menu.Item key="10">更换邮箱</Menu.Item>
                        <SubMenu key="sub3" title="Submenu">
                            <Menu.Item key="11">Option 11</Menu.Item>
                            <Menu.Item key="12">Option 12</Menu.Item>
                        </SubMenu>
                    </SubMenu>

                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>更换手机</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">更换手机</Menu.Item>
                        <Menu.Item key="10">更换手机</Menu.Item>
                    </SubMenu>

                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>更换邮箱</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">更换邮箱</Menu.Item>
                        <Menu.Item key="10">更换邮箱</Menu.Item>
                    </SubMenu>

                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>维护密保</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">维护密保</Menu.Item>
                        <Menu.Item key="10">维护密保</Menu.Item>
                    </SubMenu>

                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>维护资料</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">维护资料</Menu.Item>
                        <Menu.Item key="10">维护资料</Menu.Item>
                    </SubMenu>
                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>维护别名</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">维护别名</Menu.Item>
                        <Menu.Item key="10">维护别名</Menu.Item>
                    </SubMenu>
                </Menu>
            </div>
        )
    }
}

export default LeftNav;
